import { useMutation, useQueryClient } from '@tanstack/react-query';
import { put } from '../../utils/networking';
import { GetTeamQueryKey } from '../queries/useGetTeamByTeamId';

const updateTeamByTeamId = async (
  teamName: string,
  numberOfTeamMembers: number,
  workLanguage: 'NB' | 'EN' | null | undefined,
  teamId: number,
) =>
  put(`/api/teams/${teamId}`, {
    name: teamName,
    numberOfTeamMembers,
    workLanguage,
  });

const key = 'UPDATE_TEAM_SETTINGS';

export const useUpdateTeamSettingsMutation = (teamId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [key, teamId],
    mutationFn: ({
      teamName,
      numberOfTeamMembers,
      workLanguage,
    }: {
      teamName: string;
      numberOfTeamMembers: number;
      workLanguage?: 'NB' | 'EN' | null;
    }) => updateTeamByTeamId(teamName, numberOfTeamMembers, workLanguage, teamId),

    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [GetTeamQueryKey, teamId],
      }),
  });
};
